import { Divider, Stack, Typography } from "@mui/material";

import moment from "moment";
import React, { useState } from "react";
import { currencyFormatter } from "utils/numberFormatter";
import CircleIcon from "@mui/icons-material/Circle";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const Fees = ({ row }) => {
  const [openMore, setopenMore] = useState(false);

  return (
    <Stack width={"100%"} spacing={2} sx={{ opacity: 0.6 }}>
      <Stack
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        width={"100%"}
        spacing={2}
        direction={"row"}
      >
        <Stack flexDirection={"column"} opacity={0.5} sx={{ width: "50%" }}>
          {row?.feeName ? row?.feeName : row?.transactionType}
          <Stack spacing={1.5} direction={"row"} alignItems={"center"}>
            <CircleIcon sx={{ fontSize: "4px" }} />
            <Typography variant="small">
              {moment(new Date(row?.createdAt)).format("MMMM Do, YYYY, hh:ss")}
            </Typography>
          </Stack>
          {row.transactionType === "PHARMACY" && (
            <Stack>
              <Stack
                sx={{ cursor: "pointer" }}
                direction={"row"}
                gap={0.2}
                alignItems={"center"}
                onClick={() => setopenMore((prev) => !prev)}
              >
                <Typography
                  variant="small"
                  sx={{ textDecoration: "underline" }}
                >
                  Show more
                </Typography>
                {openMore ? (
                  <KeyboardArrowUpIcon fontSize="11px" />
                ) : (
                  <KeyboardArrowDownIcon fontSize="11px" />
                )}
              </Stack>
              {openMore && (
                <Stack px={1}>
                  {row?.itemToPayFor?.items?.map((item, idx) => (
                    <Stack
                      key={idx}
                      alignItems={"center"}
                      direction={"row"}
                      gap={1}
                    >
                      <CircleIcon sx={{ fontSize: "2px" }} />
                      <Typography variant="small">
                        {item?.product?.drugName}
                      </Typography>
                    </Stack>
                  ))}
                </Stack>
              )}
            </Stack>
          )}

          {row.transactionType === "LABORATORY" ||
          row.transactionType === "RADIOLOGY" ? (
            <Stack alignItems={"center"} direction={"row"} gap={1}>
              <CircleIcon sx={{ fontSize: "4px" }} />
              <Typography variant="small" fontWeight={"800"}>
                {row?.itemToPayFor?.test?.testName}
              </Typography>
            </Stack>
          ) : null}
        </Stack>
        <Stack
          sx={{
            width: "50%",
            justifyContent: "flex-end",
            flexDirection: "row",
          }}
        >
          <Typography variant="heading">
            {currencyFormatter(row?.totalCost)}
          </Typography>
        </Stack>
      </Stack>
      <Divider light sx={{ width: "100%" }} />
    </Stack>
  );
};

function HistorySummary({ transactionDetails = [] }) {
  return (
    <>
      <Stack
        direction={"column"}
        spacing={2}
        width={"100%"}
        sx={{
          border: "0.2px solid rgba(0,0,0,0.2)",
          borderRadius: "5px",
          p: { xs: 1, sm: 3 },
        }}
      >
        <Stack>
          <Typography variant="displaySm">Items Payed for</Typography>
        </Stack>
        {transactionDetails?.length > 0 ? (
          <Stack width={"100%"} alignItems={"flex-end"}>
            <Typography color="secondary">
              {transactionDetails?.length} item(s) selected
            </Typography>
          </Stack>
        ) : null}

        {transactionDetails?.length
          ? transactionDetails?.map((row, i) => (
              <Fees key={row?._id} row={row} />
            ))
          : null}

        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          width={"100%"}
        >
          <Typography>Total Paid</Typography>
          <Stack>
            <Typography variant="displaySm">
              {" "}
              {currencyFormatter(
                transactionDetails
                  .map((item) => item.totalCost)
                  .reduce((a, b) => a + b),
                0
              )}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}

export default HistorySummary;
